import type {ThesaurusValue} from 'services/thesaurus/types';

export const removeNodeIdFromThesaurusValue = (
  nodeId: string,
  value: ThesaurusValue,
): ThesaurusValue => {
  return value.filter(v => v !== nodeId);
};
